module.exports = __webpack_public_path__ + "img/zfb-cut.98ece053.png";